import TheftsService from "@/api/Thefts";
import { countryIdAtom, showHeatmapAtom, showModalAtom } from "@/api/atoms";
import { useAtom } from "jotai";

import { type Coordinates, GeolocateControl } from "./GeolocateControl";
import { LayerDropdown } from "./LayerDropdown";
import { Logo } from "./Logo";
import { Toggle } from "./Toggle";

export const Navigation = () => {
  const [, setShowModal] = useAtom(showModalAtom);
  const [, setShowHeatmap] = useAtom(showHeatmapAtom);

  const [, setCountryId] = useAtom(countryIdAtom);

  const handleGeolocate = async (coords: Coordinates) => {
    const locationInfo = await TheftsService.checkCoordinates({
      lat: coords.latitude,
      long: coords.longitude,
    });

    if (!locationInfo.id) {
      setCountryId(locationInfo.countryId);
      setShowModal(true);
    }
  };

  return (
    <div className="fixed top-0 z-10 flex w-screen items-center justify-between bg-gray-600/50 p-5 md:bg-transparent">
      <a href="https://bikmo.com/uk/cycle-insurance/?utm_source=bikmo&utm_medium=theftmap&utm_campaign=cliktheft/">
        <Logo />
      </a>
      <LayerDropdown />
      <div className="right-0 flex gap-3 md:fixed md:bottom-8 md:right-5 md:flex-col">
        <Toggle onClick={() => setShowHeatmap((currentShowHeatmap) => !currentShowHeatmap)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <circle cx="14.5" cy="19.5" r="1.5" fill="currentColor" />
            <circle cx="7.5" cy="20.5" r="1.5" fill="currentColor" />
            <circle cx="2.5" cy="13.5" r="1.5" fill="currentColor" />
            <circle cx="13.5" cy="13.5" r="2.5" fill="currentColor" />
            <circle cx="19.5" cy="13.5" r="1.5" fill="currentColor" />
            <circle cx="19.5" cy="4.5" r="2.5" fill="currentColor" />
            <circle cx="11.5" cy="4.5" r="4.5" fill="currentColor" />
            <circle cx="2.5" cy="4.5" r="2.5" fill="currentColor" />
          </svg>
        </Toggle>
        <GeolocateControl onGeolocate={handleGeolocate} />
      </div>
    </div>
  );
};
